import "./AppInput.scss"
import React, { FC, ReactNode } from "react"
import {
  TextField,
  FormControl,
  FormHelperText,
  InputAdornment,
  FormLabel,
  Typography,
} from "@mui/material"

type AppInputProps = {
  label: string
  name: string
  value: string
  error?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  type?: string
  className?: string
  disabled?: boolean
  startAdornment?: ReactNode
  endAdornment?: ReactNode
}

const AppInput: FC<AppInputProps> = ({
  label,
  name,
  value,
  error,
  onChange,
  onBlur,
  type = "text",
  className,
  disabled,
  startAdornment,
  endAdornment,
}) => {
  return (
    <FormControl
      error={!!error}
      className={`app-input ${className || ""}`.trim()}
    >
      <FormLabel className="label">
        <Typography className="body1">{label}</Typography>
      </FormLabel>
      <TextField
        // label={label}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className="base-input"
        error={!!error}
        disabled={disabled}
        InputProps={{
          startAdornment: startAdornment && (
            <InputAdornment position="start">{startAdornment}</InputAdornment>
          ),
          endAdornment: endAdornment && (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ),
        }}
      />
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  )
}

export default AppInput
